import React from "react";
import ReactDOM from "react-dom/client";
import "antd/dist/reset.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import store from "./redux";
import { Provider } from "react-redux";
import "dayjs/locale/zh-cn";
import locale from "antd/locale/zh_CN";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // StrictMode 用来突出显示应用程序中潜在问题的工具（严格模式）,会执行两次
  // <React.StrictMode>
  <BrowserRouter>
    <Provider store={store} locale={locale}>
      <App />
    </Provider>
  </BrowserRouter>
  // </React.StrictMode>
);
